<template>
    <div class="horizontal grow gallery-container" style="width: 70vw; height: 70vh">
        <div id="info-container">
            <p class="section-title">SYSTEM INFORMATION</p>
            <div>
                <div class="info-field horizontal">
                    <tr class="info-field-row">
                        <td style="width:200px;" class="info-field-title">System Name</td>
                        <td class="info-field-value">{{ systemObject.systemName }}</td>
                    </tr>
                </div>
                <div class="info-field horizontal">
                    <tr class="info-field-row">
                        <td style="width:200px;" class="info-field-title">Address</td>
                        <td class="info-field-value">{{ systemObject.address }}</td>
                    </tr>
                </div>
                <div class="info-field horizontal">
                    <tr class="info-field-row">
                        <td style="width:200px;" class="info-field-title">Country</td>
                        <td class="info-field-value">{{ systemObject.country }}</td>
                    </tr>
                </div>
            </div>
            <p class="section-title">CONTACT PERSON</p>
            <div>
                <div class="info-field horizontal">
                    <tr class="info-field-row">
                        <td style="width:200px;" class="info-field-title">First Name</td>
                        <td class="info-field-value">{{ contactData.contactPersonFirstName }}</td>
                    </tr>
                </div>
                <div class="info-field horizontal">
                    <tr class="info-field-row">
                        <td style="width:200px;" class="info-field-title">Last Name</td>
                        <td class="info-field-value">{{ contactData.contactPersonLastName }}</td>
                    </tr>
                </div>
                <div class="info-field horizontal">
                    <tr class="info-field-row">
                        <td style="width:200px;" class="info-field-title">Email</td>
                        <td class="info-field-value">{{ contactData.contactPersonEmail }}</td>
                    </tr>
                </div>
                <div class="info-field horizontal">
                    <tr class="info-field-row">
                        <td style="width:200px;" class="info-field-title">Phone</td>
                        <td class="info-field-value">{{ contactData.contactPersonPhoneNumber }}</td>
                    </tr>
                </div>
                <div class="info-field horizontal">
                    <tr class="info-field-row">
                        <td style="width:200px;" class="info-field-title">Responsibility</td>
                        <td class="info-field-value">{{ contactData.contactPersonResponsibility }}</td>
                    </tr>
                </div>
            </div>
            <p class="section-title">FARM OWNER</p>
            <div>
                <div class="info-field horizontal">
                    <tr class="info-field-row">
                        <td style="width:200px;" class="info-field-title">First Name</td>
                        <td class="info-field-value">{{ contactData.farmOwnerFirstName }}</td>
                    </tr>
                </div>
                <div class="info-field horizontal">
                    <tr class="info-field-row">
                        <td style="width:200px;" class="info-field-title">Last Name</td>
                        <td class="info-field-value">{{ contactData.farmOwnerLastName }}</td>
                    </tr>
                </div>
                <div class="info-field horizontal">
                    <tr class="info-field-row">
                        <td style="width:200px;" class="info-field-title">Email</td>
                        <td class="info-field-value">{{ contactData.farmOwnerEmail }}</td>
                    </tr>
                </div>
                <div class="info-field horizontal">
                    <tr class="info-field-row">
                        <td style="width:200px;" class="info-field-title">Phone</td>
                        <td class="info-field-value">{{ contactData.farmOwnerPhoneNumber }}</td>
                    </tr>
                </div>
                <div class="info-field horizontal">
                    <tr class="info-field-row">
                        <td style="width:200px;" class="info-field-title">Responsibility</td>
                        <td class="info-field-value">{{ contactData.farmOwnerResponsibility }}</td>
                    </tr>
                </div>
            </div>
        </div>
        <div id="map-container">
            <div id="map" ref="map">
            </div>
        </div>
    </div>
</template>

<script>
import mapboxgl from 'mapbox-gl';
import { getContactsBySystem } from '@api'
export default {
    props: {
        systemObject: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
          map: null,
          contactData: {
            contactPersonFirstName: '',
            contactPersonLastName: '',
            contactPersonEmail: '',
            contactPersonPhoneNumber: '',
            contactPersonResponsibility: '',
            farmOwnerFirstName: '',
            farmOwnerLastName: '',
            farmOwnerEmail: '',
            farmOwnerPhoneNumber: '',
            farmOwnerResponsibility: '',
            farmAddress: '',
            farmCountry: '',
            addressLatitude: 0,
            addressLongitude: 0
          }
        }
    },
    methods: {
      async getData() {
        this.contactData = await getContactsBySystem(this.systemObject.id);
      },
      async createMap() {
        mapboxgl.accessToken = 'pk.eyJ1Ijoicml2aWpjenlrOTgiLCJhIjoiY2thNWxvYnZ4MDFhcjNtbXdlOGRkZHlpNyJ9.3yvf9A68MAvVM9OG1ZK9pg';
        await this.getData();

        this.map = new mapboxgl.Map({
            container: 'map', // container ID
            style: 'mapbox://styles/mapbox/satellite-streets-v11', // style URL
            center: [this.contactData.addressLongitude, this.contactData.addressLatitude], // starting position [lng, lat]
            zoom: 5 // starting zoom
        });

        this.map.addControl(new mapboxgl.NavigationControl());

        var marker = new mapboxgl.Marker({ color: ['#3CD6B1', '#FFBD6D', '#FF6666', '#AAAAAA'][this.systemObject.lastUpdate != undefined && this.systemObject.lastUpdate=='0001-01-01T00:00:00' ? 3 : this.systemObject.statusTab[0][1]] })
            .setLngLat([this.contactData.addressLongitude, this.contactData.addressLatitude])
            .setPopup()
            .addTo(this.map);

        // this.getData();
        // this.map = new window.google.maps.Map(this.$refs["map"], {
        //   center: { lat: this.systemObject.addressLatitude, lng: this.systemObject.addressLongitude },
        //   zoom: 7
        // });

        // new window.google.maps.Marker({
        //   position: {lat: this.systemObject.addressLatitude, lng: this.systemObject.addressLongitude},
        //   map: this.map
        // })
    }
    },
    mounted: async function() {
        await this.getData();
        this.createMap();
    },
}
</script>

<style scoped>
#info-container {
    width: 30%;
    padding: 20px;

    background: #FFFFFF;
    border: 1px solid #EFEFEF;
    box-sizing: border-box;
    box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.1);
    border-radius: 5px 0px 0px 5px;
}

#map-container {
    width: 70%;
}

.gallery-container {
    background: #F9F9F9;
    box-shadow: 0px 0px 40px rgba(53, 110, 138, 0.25);
    border-radius: 5px;
}

.info-field {
    border-bottom: 1px solid #E9E9E9;
    margin-bottom: 12px;
    margin-top: 12px;
}

.info-field-title {
    font-style: normal;
    font-weight: 600;
    font-size: 12px;
    line-height: 16px;

    color: #272727;
}

.info-field-row {
    width: 100%;
    margin: 0;
    padding-bottom: 5px;
}

.info-field-value {
    font-style: normal;
    font-weight: normal;
    font-size: 12px;
    line-height: 16px;

    color: #272727;
}

.section-title {
    font-weight: bold;
}

#map {
 height: 95%;
 background: gray;
 margin: 20px;
 border-radius: 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/Systems/ContactModal.vue